$(function() {
    $('.list-generic__item--has-more').each(function() {
        var $el = $(this);
        $('.list-generic__item-content', $el).click(function() {
            $el.toggleClass('list-generic__item--is-open');
        });
    })
})